<template>
  <v-container grid-list>
    <div v-if="skeleton_type === SkeletonType.type1">
      <v-skeleton-loader
        v-for="n in 3"
        :key="n"
        v-bind="attrs"
        type="card-heading, list-item, list-item, list-item"
      />
      <v-skeleton-loader
        v-bind="attrs"
        type="actions"
      />
    </div>
    <div v-if="skeleton_type === SkeletonType.type2">
      <v-row
        v-for="n in 2"
        :key="n"
      >
        <v-col
          v-for="m in 2"
          :key="m"
        >
          <v-skeleton-loader
            v-bind="attrs"
            type="card-heading"
          />
          <v-row
            v-for="o in 2"
            :key="o"
          >
            <v-col
              v-for="p in 2"
              :key="p"
            >
              <v-skeleton-loader
                v-bind="attrs"
                type="image"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-skeleton-loader
        v-bind="attrs"
        type="actions"
      />
    </div>
    <div v-if="skeleton_type === SkeletonType.type3">
      <v-row
        v-for="n in 2"
        :key="n"
      >
        <v-col
          v-for="m in 3"
          :key="m"
        >
          <v-skeleton-loader
            v-bind="attrs"
            type="image"
          />
        </v-col>
      </v-row>
      <v-skeleton-loader
        v-bind="attrs"
        type="actions"
      />
    </div>
    <div v-if="skeleton_type === SkeletonType.type4">
      <v-skeleton-loader
        v-for="n in 5"
        :key="n"
        v-bind="attrs"
        type="card-heading, list-item"
      />
      <v-skeleton-loader
        v-bind="attrs"
        type="actions"
      />
    </div>
    <div v-if="skeleton_type === SkeletonType.type5">
      <v-skeleton-loader
        v-bind="attrs"
        type="table, actions"
      />
    </div>
    <div v-if="skeleton_type === SkeletonType.type6">
      <div
        v-for="n in 3"
        :key="n"
      >
        <v-skeleton-loader
          v-bind="attrs"
          type="card-heading"
          max-width="300px"
        />
        <v-row>
          <v-col
            v-for="m in 2"
            :key="m"
          >
            <v-skeleton-loader
              v-bind="attrs"
              type="list-item"
            />
          </v-col>
        </v-row>
      </div>
      <v-skeleton-loader
        v-bind="attrs"
        type="actions"
      />
    </div>
    <div v-if="skeleton_type === SkeletonType.type7">
      <v-skeleton-loader
        v-bind="attrs"
        type="card-heading"
      />
      <v-row
        v-for="n in 5"
        :key="`row-${n}`"
      >
        <v-col
          v-for="m in 2"
          :key="`col-${n}-${m}`"
        >
          <v-skeleton-loader
            v-bind="attrs"
            type="list-item"
          />
        </v-col>
        <v-spacer
          v-for="o in 4"
          :key="`spacer-${n}-${o}`"
        />
      </v-row>
      <v-skeleton-loader
        v-bind="attrs"
        type="actions"
      />
    </div>
    <div v-if="skeleton_type === SkeletonType.type8">
      <v-skeleton-loader
        v-bind="attrs"
        type="card-heading"
        max-width="300px"
      />
      <v-row
        v-for="n in 3"
        :key="n"
      >
        <v-col
          v-for="m in 4"
          :key="m"
        >
          <v-skeleton-loader
            v-bind="attrs"
            type="list-item"
          />
        </v-col>
      </v-row>
      <v-skeleton-loader
        v-bind="attrs"
        type="actions"
      />
    </div>
  </v-container>
</template>

<script>
const SkeletonType = Object.freeze({
  type1: "UdajeOKlientovi",
  type2: "Swot",
  type3: "RizikaADohlad",
  type4: "PotrebyPlan",
  type5: "SocialneProgramy",
  type6: "AktualnyStav",
  type7: "PrehladZmien",
  type8: "Spracovatelia",
});

export default {
  name: "FormSkeleton",
  props: {
    skeleton_type: { type: String, required: true },
  },
  data: () => ({
    attrs: {
      boilerplate: false,
    },
    SkeletonType,
  }),
};
</script>>